import types from '../constants/actionTypes';

const filterOptions = (state, action) => {
  switch (action.type) {
    case types.dataFetching.FILTER_OPTIONS_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.FILTER_OPTIONS_REQUEST_SUCCESS:
      state = state.merge(action.payload.filterOptions)
                    .set('isFetching', false);
      break;
    case types.dataFetching.FILTER_OPTIONS_REQUEST_ERROR:
      state = state.set('isFetching', false);
      break;
  }
  return state;
};

export default filterOptions;



/** WEBPACK FOOTER **
 ** ./reducers/filterOptions.js
 **/